export default "__VITE_ASSET__489e0e68__"